// React
import React, { useState, Fragment } from 'react';

// UI
import { AppBar, Box, Dialog, Fab, IconButton, Slide, Toolbar, Typography } from '@mui/material';
import PrimaryButton from '../ui/buttons/primaryButton';
import CloseIcon from '@mui/icons-material/CloseOutlined';

// Components
import ImportPlayerDialog from '../players/importPlayerDialog';
import PlayersPanel from '../players/playersPanel';
import PlayersTeamsManager from './playersTeamsManager';

// Icons
import PlayerIcon from '@mui/icons-material/Person';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EventPlayerSetupDialog = ({
  trigger = null,
  readOnly = false,
  canReplacePlayer = true,
  canPromoteReserve = false
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      {trigger ? (
        React.cloneElement(trigger, { onClick: handleOpen })
      ) : (
        <Fab
          size="small"
          color="primary"
          aria-label="add"
          onClick={handleOpen}
          variant="extended"
          sx={{ fontSize: '0.7rem' }}>
          <PlayerIcon />
          Players
        </Fab>
      )}
      <Dialog open={open} onClose={handleClose} fullScreen TransitionComponent={Transition}>
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {readOnly ? 'Players' : 'Player & Team Setup'}
            </Typography>
            {!readOnly ? <ImportPlayerDialog /> : null}
            <PrimaryButton autoFocus color="inherit" onClick={handleClose}>
              Close
            </PrimaryButton>
          </Toolbar>
        </AppBar>

        <Box sx={{ p: 2 }}>
          {readOnly ? (
            <PlayersPanel readOnly />
          ) : (
            <PlayersTeamsManager
              canReplacePlayer={canReplacePlayer}
              canPromoteReserve={canPromoteReserve}
            />
          )}
        </Box>
      </Dialog>
    </Fragment>
  );
};

export default EventPlayerSetupDialog;
